module.exports = __webpack_public_path__ + "img/ruby-stencil.84890741.svg";